import {
  FilterDisclosure,
  FilterFooter,
  FilterListbox,
  FilterOptionRadio,
  FilterPopover,
} from '@vtex/admin-ui'
import { defineMessages, useIntl } from 'react-intl'
import type { SimplifiedPromotion } from 'typings'
import { usePromotionsFilterState } from '../useFiltersState'

export const DAY_MS = 1000 * 60 * 60 * 24

const messages = defineMessages({
  label: { id: 'admin/promotions.filters.last-modified' },
  yesterday: { id: 'admin/promotions.filters.last-modified.yesterday' },
  days: { id: 'admin/promotions.filters.last-modified.days' },
  months: { id: 'admin/promotions.filters.last-modified.months' },
})

const filterByLastModified = (
  promotion: SimplifiedPromotion,
  lastModified: string | undefined
) => {
  return (
    lastModified === undefined ||
    new Date(promotion.lastModified).getTime() >
      Date.now() - Number(lastModified)
  )
}

export function FilterByLastModified() {
  const { formatMessage } = useIntl()

  const state = usePromotionsFilterState({
    id: 'lastModified',
    filterFn: (item) => filterByLastModified(item, state.appliedItem?.id),
  })

  const options = [
    {
      id: String(DAY_MS),
      label: formatMessage(messages.yesterday),
    },
    {
      id: String(DAY_MS * 7),
      label: formatMessage(messages.days, { value: 7 }),
    },
    {
      id: String(DAY_MS * 30),
      label: formatMessage(messages.days, { value: 30 }),
    },
    {
      id: String(DAY_MS * 90),
      label: formatMessage(messages.months, { value: 3 }),
    },
    {
      id: String(DAY_MS * 365),
      label: formatMessage(messages.months, { value: 12 }),
    },
  ]

  return (
    <>
      <FilterDisclosure state={state}>
        {formatMessage(messages.label)}
      </FilterDisclosure>
      <FilterPopover state={state}>
        <FilterListbox>
          {options.map((item) => (
            <FilterOptionRadio key={item.id} {...item} />
          ))}
        </FilterListbox>
        <FilterFooter />
      </FilterPopover>
    </>
  )
}
